// Tiny vendored SVG icons — no dep, tree-shakable, themable via currentColor.
// Stroke width / size standardized via the cx() helper.

import type { SVGProps } from 'react';

type IconProps = SVGProps<SVGSVGElement> & { size?: number };

const base = (size = 16): SVGProps<SVGSVGElement> => ({
  width: size, height: size,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.75,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
});

export const ActivityIcon = ({ size, ...p }: IconProps) => (
  <svg {...base(size)} {...p}><path d="M22 12h-4l-3 9L9 3l-3 9H2"/></svg>
);
export const AlertIcon = ({ size, ...p }: IconProps) => (
  <svg {...base(size)} {...p}><path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><path d="M12 9v4"/><circle cx="12" cy="17" r="0.5" fill="currentColor"/></svg>
);
export const BoxIcon = ({ size, ...p }: IconProps) => (
  <svg {...base(size)} {...p}><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/></svg>
);
export const ChartIcon = ({ size, ...p }: IconProps) => (
  <svg {...base(size)} {...p}><path d="M3 3v18h18"/><path d="M7 14l4-4 4 4 5-6"/></svg>
);
export const ChevronRightIcon = ({ size, ...p }: IconProps) => (
  <svg {...base(size)} {...p}><polyline points="9 18 15 12 9 6"/></svg>
);
export const ClockIcon = ({ size, ...p }: IconProps) => (
  <svg {...base(size)} {...p}><circle cx="12" cy="12" r="9"/><polyline points="12 7 12 12 15 14"/></svg>
);
export const DotIcon = ({ size, ...p }: IconProps) => (
  <svg {...base(size)} {...p}><circle cx="12" cy="12" r="4" fill="currentColor"/></svg>
);
export const FolderIcon = ({ size, ...p }: IconProps) => (
  <svg {...base(size)} {...p}><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/></svg>
);
export const KeyIcon = ({ size, ...p }: IconProps) => (
  <svg {...base(size)} {...p}><circle cx="7.5" cy="15.5" r="3.5"/><path d="m10 13 9-9"/><path d="m17 6 3 3"/></svg>
);
export const LogoutIcon = ({ size, ...p }: IconProps) => (
  <svg {...base(size)} {...p}><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>
);
export const PauseIcon = ({ size, ...p }: IconProps) => (
  <svg {...base(size)} {...p}><rect x="6" y="5" width="4" height="14" rx="1"/><rect x="14" y="5" width="4" height="14" rx="1"/></svg>
);
export const PlayIcon = ({ size, ...p }: IconProps) => (
  <svg {...base(size)} {...p}><polygon points="6 4 20 12 6 20 6 4" fill="currentColor"/></svg>
);
export const PlusIcon = ({ size, ...p }: IconProps) => (
  <svg {...base(size)} {...p}><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
);
export const RefreshIcon = ({ size, ...p }: IconProps) => (
  <svg {...base(size)} {...p}><polyline points="23 4 23 10 17 10"/><polyline points="1 20 1 14 7 14"/><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/></svg>
);
export const SearchIcon = ({ size, ...p }: IconProps) => (
  <svg {...base(size)} {...p}><circle cx="11" cy="11" r="7"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
);
export const TrashIcon = ({ size, ...p }: IconProps) => (
  <svg {...base(size)} {...p}><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>
);
export const UsersIcon = ({ size, ...p }: IconProps) => (
  <svg {...base(size)} {...p}><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
);
export const ZapIcon = ({ size, ...p }: IconProps) => (
  <svg {...base(size)} {...p}><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>
);
